export default {
  site_title: '展会网',
  more: '更多',
  packUp: '收起',
  view: '查看',
  internation: '国际',
  china: '国内',
  industry: '行业',
  fair: '展会',
  expo: '展会',
  concurrentFair: '同期展会',
  vote: '门票',
  search: '搜索',
  boothInquiry: '展位咨询',
  ticketBooking: '门票预定',
  exhibitorECatalog: '展商/电子会刊查看',
  booth: '展位',
  ticket: '门票',
  catalog: '会刊'
}
